import { CustomStepEdge } from "./custom-step-edge";
import { CustomSmoothEdge } from "./custom-smooth-edge";
import { CustomStraightEdge } from "./custom-straight-edge";
import { CustomTwoPointEdge } from "./custom-two-point-edge";

export const edgeTypes = {
    customStep: CustomStepEdge,
    customSmooth: CustomSmoothEdge,
    customStraight: CustomStraightEdge,
    customTwoPoint: CustomTwoPointEdge,
};
